import React from "react";

export default [
  {
    name: "Fieldinsight",
    role: "Product Designer",
    image:
      "https://res.cloudinary.com/chudi/image/upload/v1580169079/fieldinsight.svg",
    website: "https://fieldinsight.co",
    description: (
      <p className="project__description">
        Fieldinsight is a customer relationship management solution built for
        activities in the field to strengthen companies’ bond with their
        customers. It's a platform that works offline and online helping your
        team in the field — including, field-sales, customer service and
        logistics, all work together to ensure customer satisfaction. I worked
        on the company website in the link above, also worked on various in
        house apps doing research, design and prototyping.
      </p>
    )
  },
  {
    name: "Chivar Clinics",
    role: "Lead Product Designer",
    image:
      "https://res.cloudinary.com/chudi/image/upload/v1580169081/Chivar_Landing.svg",
    website: "https://chivar.herokuapp.com",
    description: (
      <p className="project__description">
        Chivar is for a hospital website based in Abuja, Nigeria. Chivar was
        established on the 12th of October 2007. This website revamp project was
        done within Deccember 2019 - May 2020 myself and my wonderful team
        worked on this project which is still in production. For this project, I
        was in charge of the design work i.e the logo, wireframes and
        prototyping both for mobile and web. This is one of my best work done
        because it made me discover a side in design I didn’t know I had yet.
      </p>
    )
  },
  {
    name: "Not3s",
    role: "Lead Product Designer",
    image:
      "https://res.cloudinary.com/chudi/image/upload/v1580168927/Landing_page.svg",
    website: "shorturl.do/2rpmx",
    description: (
      <p className="project__description">
        Not3s is a web app made for joting down notes, both important and
        unimportant, for this work, the goal is to be able to write notes and
        sort, star them so it’s easy to identify them. For this project, I was
        in charge of the design work i.e the logo, wireframes and prototyping
        both for mobile and web.
      </p>
    )
  }
];
